import { H5, H6 } from 'AbstractElements';
import { Col, Card, CardHeader, Table } from 'reactstrap';
import React, { Fragment, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { setFormData } from 'Services/Features/Treatment/treatmentSlice';
import { handleDelete } from 'Component/DashboardQeza/Common/DeleteUtils';
import { deleteTreatment } from 'Services/Features/Treatment/Utils/treatmentUtils';
import PaginationComponent from 'Component/Common/PaginationComponent';
import CurrencyFormatter from 'Component/Common/Formatter/CurrencyFormatter';
import { setFilters } from 'Services/Features/Treatment/treatmentSlice';
import {
    handleNextPagination,
    handleBackPagination,
    handleClickPagination
} from 'Component/DashboardQeza/Common/PaginationUtils';
const TreatmentTable = ({ setRefetch }) => {
  const treatments = useSelector((state) => state.treatment.treatments);
  const loading = useSelector((state) => state.treatment.loading);
  const pagination = useSelector((state) => state.treatment.pagination);
  const filters = useSelector(state => state.treatment.filters);

    // const currentCategory = useSelector((state) => state.category.currentCategory);
  const dispatch = useDispatch();
  const history = useNavigate();


  const handleEdit = (item) => {
      console.log(item, 'handleEditItem');
      // Simpan data photos dan banner ke state terpisah
      dispatch(setFormData({ photosLink: item.photos }));

      // Buat objek baru tanpa banner
      const { photos, ...updatedItem } = item;

      dispatch(setFormData({
          ...updatedItem,
          category_id: item.category?.id,
      }));

      history(`${process.env.PUBLIC_URL}/treatment/edit/${item.id}`);
  };

  return (
    <Fragment>
      <Col sm="12" lg="12" xl="12">
        <Card>
          <CardHeader>
            <H5>Layanan Perawatan</H5>
            <span>{'Kelola data layanan perawatan, termasuk'} <code>benefits, proses, dan foto perawatan.</code> {'Gunakan fitur pencarian dan filter untuk menemukan data lebih cepat.'}</span>
          </CardHeader>          
          <div className="mb-5">
            <Col sm="12" lg="12" xl="12">
                <div className="table-responsive">
                  <Table className=" table-hover table-border-vertical">
                    <thead className="bg-primary">
                      <tr>
                        <th scope="col" className="sticky-col-number"style={{ width: '15px' }}>{'#'}</th>
                        <th scope="col" className="sticky-col-name" style={{ whiteSpace: 'nowrap', overflow: 'hidden' }}>{'Nama Perawatan'}</th>
                        <th scope="col">{'Kategori'}</th>
                        <th scope="col" style={{ width: '100px' }}>{'Biaya'}</th>
                        <th scope="col">{'Deskripsi'}</th>
                        <th scope="col" className="text-center" style={{ width: '15px' }} >{'Aksi'}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        treatments && treatments.map((item, i) => 
                          <tr key={item.id}>
                            <th className="sticky-col-number" scope="row" style={{ verticalAlign: "top" }}>{i + 1}</th>
                            <td className="sticky-col-name">{item.name}</td>
                            <td>{item.category?.name}</td>
                            <td style={{ maxWidth: 'auto', whiteSpace: 'nowrap', overflow: 'hidden' }}>
                              {item.gimmick_price && (
                                <span className="d-block" style={{ textDecoration: 'line-through', marginRight: '8px', color: 'red' }}>
                                  <CurrencyFormatter amount={item.gimmick_price} />
                                </span>
                              )}
                              <CurrencyFormatter amount={item.price} />
                            </td>
                            <td style={{ maxWidth: '300px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', cursor: 'pointer' }} title={item.description}>
                              {item.description?.length > 70 ? `${item.description?.slice(0, 70)}...` : item.description}
                            </td>
                            <td>
                              <div className="d-flex">
                                <button
                                  title="Edit"
                                  className="btn btn-primary"
                                  style={{ padding: '4px 8px', fontSize: '12px' }}
                                  onClick={() => handleEdit(item)}
                                >
                                  <i className="fa fa-pencil"></i>
                                </button>

                                <button
                                  title="Hapus"
                                  className="btn btn-danger ms-2"
                                  style={{ padding: '4px 8px', fontSize: '12px' }}
                                  onClick={() => handleDelete(dispatch, item.id, setRefetch, deleteTreatment)}
                                >
                                  <i className="fa fa-trash"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        )
                      }
                    </tbody>
                  </Table>
                </div>
              <div style={{ marginTop: '100px', display: 'flex', justifyContent: 'center' }}>
                {loading === false && treatments && treatments.length > 0 && (
                  <PaginationComponent
                    pagination={pagination}
                    handleBackPagination={() => handleBackPagination(pagination, filters, dispatch, setFilters, setRefetch)}
                    handleClickPagination={(page) => handleClickPagination(page, filters, dispatch, setFilters, setRefetch)}
                    handleNextPagination={() => handleNextPagination(pagination, filters, dispatch, setFilters, setRefetch)}
                  />
                )}
              </div>
            </Col>
          </div>
        </Card>
      </Col>
    </Fragment>
  );
};

export default TreatmentTable;